
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.content-wrapper{
  display:flex;
  flex-direction:column;
  gap:var(--sic-featured-content-hero--default--spacing);
  gap:var(
    --sic-featured-content-hero--spacing,
    var(--sic-featured-content-hero--default--spacing)
  );
  padding-top:var(--sic-featured-content-hero--default--spacing);
  padding-top:var(
    --sic-featured-content-hero--spacing,
    var(--sic-featured-content-hero--default--spacing)
  );
}
.text-wrapper{
}
.hero-eyebrow{
  font-size:var(--headline-eyebrow-font-size);
  line-height:var(--headline-eyebrow-line-height);
}
.hero-heading{
  font-size:var(--sic-featured-content-hero--default--heading-size);
  font-size:var(
    --sic-featured-content-hero--heading-size,
    var(--sic-featured-content-hero--default--heading-size)
  );
  line-height:var(--sic-featured-content-hero--default--heading-line-height);
  line-height:var(
    --sic-featured-content-hero--heading-line-height,
    var(--sic-featured-content-hero--default--heading-line-height)
  );
  font-weight:var(--fw-bold);
}
::slotted([slot='hero-card']){
  max-width:90rem;
}
@media (min-width: 1024px){
  .text-wrapper{
    width:calc(100% * 2 / 3);
  }
}
`;